export default function Philosophy() {
  return (
    <section className="py-32 px-8 bg-[#F5F5F7]">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-5xl md:text-6xl font-light text-[#0E1A2B] mb-12 text-center tracking-tight">
          Strategy Before Automation
        </h2>
        
        <div className="space-y-8">
          <p className="text-xl font-light text-[#5C6675] leading-relaxed">
            Many companies rush into AI tools without aligning them to their operational workflows.
          </p>
          
          <p className="text-xl font-light text-[#5C6675] leading-relaxed">
            We take a disciplined approach:
          </p>
          
          <ul className="space-y-4 text-xl font-light text-[#5C6675] pl-0">
            <li className="flex items-start">
              <span className="text-[#28D7C6] mr-3 mt-1">•</span>
              <span>Audit operations</span>
            </li>
            <li className="flex items-start">
              <span className="text-[#28D7C6] mr-3 mt-1">•</span>
              <span>Design structured systems</span>
            </li>
            <li className="flex items-start">
              <span className="text-[#28D7C6] mr-3 mt-1">•</span>
              <span>Implement intelligent automation</span>
            </li>
            <li className="flex items-start">
              <span className="text-[#28D7C6] mr-3 mt-1">•</span>
              <span>Measure performance</span>
            </li>
          </ul>
          
          <p className="text-xl font-light text-[#5C6675] leading-relaxed mt-8">
            This ensures AI becomes an operational advantage — not another disconnected tool.
          </p>
        </div>
      </div>
    </section>
  );
}